/* rc-reveal — scroll-reveal + subtle parallax for editorial galleries (spec §7).
   No such utility exists in the theme. Load once with defer.
   - [data-rc-reveal]            → fades/rises in when it enters the viewport.
       optional inline style --rc-reveal-i = stagger index (0,1,2…).
   - [data-rc-parallax="0.12"]   → drifts on scroll, DESKTOP only (≥990px).
   Respects prefers-reduced-motion (reveals immediately, no parallax). */
(function () {
  if (window.__rcRevealInit) return;
  window.__rcRevealInit = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveal(scope) {
    var els = (scope || document).querySelectorAll('[data-rc-reveal]:not(.rc-reveal--in)');
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('rc-reveal--in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          en.target.classList.add('rc-reveal--in');
          io.unobserve(en.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  function parallax() {
    if (reduce) return;
    var els = Array.prototype.slice.call(document.querySelectorAll('[data-rc-parallax]'));
    if (!els.length) return;

    var desktop = window.matchMedia('(min-width: 990px)');
    var ticking = false;

    function update() {
      ticking = false;
      if (!desktop.matches) { els.forEach(function (el) { el.style.transform = ''; }); return; }
      var vh = window.innerHeight;
      els.forEach(function (el) {
        var speed = parseFloat(el.getAttribute('data-rc-parallax')) || 0.1;
        var r = el.getBoundingClientRect();
        var off = ((r.top + r.height / 2) - vh / 2) / vh;   // ~ -0.5..0.5
        el.style.transform = 'translate3d(0,' + (-off * speed * 100).toFixed(1) + 'px,0)';
      });
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    if (desktop.addEventListener) desktop.addEventListener('change', onScroll);
    update();
  }

  function start() { reveal(document); parallax(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  // Theme editor: re-scan a reloaded section.
  document.addEventListener('shopify:section:load', function (e) { reveal(e.target); });
})();
